
export const enableAppProtection = () => {

  document.addEventListener("contextmenu", (e) => e.preventDefault());


  document.addEventListener("keydown", (e) => {
    if (
      e.key === "F12" || // DevTools
      (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") || // Ctrl+Shift+I
      (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "j") || // Ctrl+Shift+J
      (e.ctrlKey && e.key.toLowerCase() === "u") // View Source
    ) {
      e.preventDefault();
    }
  });

  document.addEventListener("selectstart", (e) => e.preventDefault());

  // Disable drag on images
  document.addEventListener("dragstart", (e) => e.preventDefault());

  // Try to detect DevTools open (basic method)
  setInterval(() => {
    if (window.outerWidth - window.innerWidth > 200 || window.outerHeight - window.innerHeight > 200) {
      alert("Developer tools detected. Please close them to continue.");
      window.location.reload();
    }
  }, 1000);
};
